import { Component, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Nav, Platform } from 'ionic-angular';
import { RecordsPage } from '../pages/records/records/records';
import { SessionPage } from '../pages/session/session';
import { SettingsPage } from '../pages/settings/settings';
import { DataProvider } from '../provider/data-service';
import { SettingsProvider } from './../provider/settings-service';


@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    @ViewChild(Nav) nav: Nav;

    public rootPage: any = SessionPage;

    public pages: Array<{ title: string, component: any }>;

    public dataReady = false;

    constructor(
        public platform: Platform,
        public statusBar: StatusBar,
        public splashScreen: SplashScreen,
        private dataProvider: DataProvider,
        private settingsProvider: SettingsProvider
    ) {
        this.initializeApp();

        // used for an example of ngFor and navigation
        this.pages = [
            { title: 'Sitzung durchführen', component: SessionPage },
            { title: 'Aufzeichnungen', component: RecordsPage },
            { title: 'Einstellungen', component: SettingsPage },
            // { title: 'MPT', component: MPTPage },
            // { title: 'Anleitung', component: InstructionsPage },
        ];
    }

    private initializeApp() {
        this.dataProvider.load().subscribe(history => {
            this.settingsProvider.load().subscribe(settings => {
                // Root-Page erste anzeigen, wenn daten geladen wurden.
                // Das passiert, da die Root-Page erst instanziert wird, wenn <ion-nav> vorhanden ist
                this.dataReady = true;
            });
        });

        this.platform.ready().then(() => {
            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }

    public openPage(page) {
        // Reset the content nav to have just this page
        // we wouldn't want the back button to show in this scenario
        this.nav.setRoot(page.component);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts